import * as yup from "yup";
import { getCheckedEmotionRating } from "./toString";

export const validateConditionalSchema = async (formData, currentStepIndex) => {
  switch (currentStepIndex) {
    case 5:
      return await validateQuestionFive(formData);
    case 7:
      return await validateQuestionSeven(formData);
    case 9:
      return await validateQuestionNine(formData);
    case 10:
      return await validateQuestionTen(formData)
    case 11:
      return await validateQuestionEleven(formData)
    default:
      return;
  }
};

export const questionFiveSchema = yup.object().shape({
  flashCoachPlatformRating: yup
    .string()
    .min(1, "Conditional Input was not filled"),
});

export const validateQuestionFive = async formData => {
  try {
    await questionFiveSchema.validate(formData);
    return { success: "Conditional Input criteria met" };
  } catch (error) {
    return { action: "SKIP_QUESTION", error: error.message };
  }
};
export const questionSevenSchema = yup.number().lessThan(7, "6 stars or below");

export const validateQuestionSeven = async formData => {
  let parseResult = getCheckedEmotionRating(
    formData.easeOfNavigationRating ?? formData
  );
  if (parseResult === "") {
    parseResult = null;
  }

  try {
    await questionSevenSchema.validate(parseResult);
    return { success: "Conditional Input criteria met" };
  } catch (error) {
    return { action: "SKIP_QUESTION", error: error.message };
  }
};
export const questionNineSchema = yup.number().lessThan(7, "6 stars or below");

export const validateQuestionNine = async formData => {
  let parseResult = getCheckedEmotionRating(
    formData.accessibilityRating ?? formData
  );
  if (parseResult === "") {
    parseResult = null;
  }

  try {
    await questionNineSchema.validate(parseResult);
    return { success: "Conditional Input criteria met" };
  } catch (error) {
    return { action: "SKIP_QUESTION", error: error.message };
  }
};

export const questionTenSchema = yup.object().shape({
  accessibilityFactors: yup
    .array()
    .of(
      yup.object({
        id: yup.string(),
        description: yup.string(),
        checked: yup.boolean(),
      })
    )
    .test("is the 'Others' field selected", "Others field was selected", options => {
      return options.some(item => item.id === "5" && item.checked);
    }),
});

export const validateQuestionTen = async formData => {
  try {
    await questionTenSchema.validate(formData);

    return { action: "SHOW_TEXT_INPUT", success: "Conditional Input criteria met" };
  } catch (error) {
    return { action: "HIDE_TEXT_INPUT", error: error.message };
  }
};


export const questionElevenSchema = yup.object().shape({
  helpfulFeatures: yup
    .array()
    .of(
      yup.object({
        id: yup.string(),
        description: yup.string(),
        checked: yup.boolean(),
      })
    )
    .test("is the 'Others' field selected", "Others field was selected", options => {
      return options.some(item => item.id === "6" && item.checked);
    }),
});

export const validateQuestionEleven = async formData => {
  try {
    await questionElevenSchema.validate(formData);
    return { action: "SHOW_TEXT_INPUT", success: "Conditional Input criteria met" };
  } catch (error) {
    return { action: "HIDE_TEXT_INPUT", error: error.message };
  }
};